
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/legal-stuff",
      function () {
        return require("private-next-pages/de/legal-stuff.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/legal-stuff"])
      });
    }
  